// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#efzk-modernizationconvoy .gc-multiple-choice-checkbox{flex-shrink:0;display:flex;cursor:pointer;color:#fff;font-size:75%;align-items:center;justify-content:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
